export default __webpack_public_path__ + "static/media/place.d19fe3cc.svg";